import logo from "@/assets/logo.png";

export function Header() {
  return (
    <header className="sticky top-0 z-50 w-full border-b border-border/40 bg-background/80 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <a href="/" className="flex items-center gap-2">
          <img src={logo} alt="Hummany" className="h-8 w-auto" />
        </a>
        <nav className="hidden items-center gap-8 md:flex">
          <a href="#problema" className="text-sm text-muted-foreground transition hover:text-foreground">El problema</a>
          <a href="#como-funciona" className="text-sm text-muted-foreground transition hover:text-foreground">Cómo funciona</a>
          <a href="#producto" className="text-sm text-muted-foreground transition hover:text-foreground">Producto</a>
          <a href="#beneficios" className="text-sm text-muted-foreground transition hover:text-foreground">Beneficios</a>
          <a href="#privacidad" className="text-sm text-muted-foreground transition hover:text-foreground">Privacidad</a>
        </nav>
        <div className="flex items-center gap-2">
          <a
            href="/app"
            className="inline-flex items-center justify-center rounded-full px-4 py-2 text-sm font-medium text-foreground transition hover:bg-muted"
          >
            Iniciar sesión
          </a>
          <a
            href="#cta"
            className="inline-flex items-center justify-center rounded-full bg-foreground px-4 py-2 text-sm font-medium text-background transition hover:bg-foreground/90"
          >
            Solicitar demo
          </a>
        </div>
      </div>
    </header>
  );
}
